import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider from './contexts/AuthProvider';
import { ThemeProvider } from './contexts/ThemeProvider';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import SSOCallback from './pages/SSOCallback';
import ETLDashboard from './pages/ETLDashboard';
import FlowsList from './pages/FlowsList';
import FlowDetail from './pages/FlowDetail';
import FlowCreator from './pages/FlowCreator';
import FieldSelector from './pages/FieldSelector';
import MultiSourceBuilder from './pages/MultiSourceBuilder';
import PipelineBuilder from './pages/PipelineBuilder';
import RunsList from './pages/RunsList';
import RunDetail from './pages/RunDetail';
import Schedules from './pages/Schedules';
import PipelinesList from './pages/PipelinesList';
import PipelineDetail from './pages/PipelineDetail';
import PipelineCreator from './pages/PipelineCreator';
import RunProfiles from './pages/RunProfiles';
import RunProfileDetail from './pages/RunProfileDetail';
import Lineage from './pages/Lineage';
import './App.css';

/**
 * Main App component
 * Sets up routing and authentication provider
 */
function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Public route for login */}
              <Route path="/login" element={<Login />} />
              <Route path="/sso-callback" element={<SSOCallback />} />
              
              {/* Protected routes with Layout */}
              <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route path="/etl" element={<ETLDashboard />} />
                <Route path="/flows" element={<FlowsList />} />
                <Route path="/flows/new" element={<FlowCreator />} />
                <Route path="/flows/new/field-selector" element={<FieldSelector />} />
                <Route path="/flows/new/multi-source" element={<MultiSourceBuilder />} />
                <Route path="/flows/:id" element={<FlowDetail />} />
                <Route path="/flows/:flowId/edit" element={<PipelineBuilder />} />
                <Route path="/runs" element={<RunsList />} />
                <Route path="/runs/:id" element={<RunDetail />} />
                <Route path="/schedules" element={<Schedules />} />
                <Route path="/pipelines" element={<PipelinesList />} />
                <Route path="/pipelines/new" element={<PipelineCreator />} />
                <Route path="/pipelines/:id" element={<PipelineDetail />} />
                <Route path="/run-profiles" element={<RunProfiles />} />
                <Route path="/run-profiles/:id" element={<RunProfileDetail />} />
                <Route path="/lineage" element={<Lineage />} />
              </Route>
              
              {/* Default redirect to ETL dashboard */}
              <Route path="/" element={<Navigate to="/etl" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
